import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';
import CommonProps from '@components/shared/mixins/props';

/**
 * Pagination Props
 */
@Component
class Props extends Mixins(CommonProps) {
    /**
     * Last page number
     */
    @Prop({ type: [Number, String], required: true }) lastPage!: number;

    /**
     * Active button for jump to end or start
     */
    @Prop({ type: Boolean }) jumper!: boolean;

    /**
     * Disable mode
     */
    @Prop({ type: Boolean }) disabled!: boolean;

    /**
     * Add border-radius: 50% to active item
     */
    @Prop({ type: Boolean }) circle!: boolean;

    /**
     * Text mode
     */
    @Prop({ type: Boolean }) text!: boolean;

    /**
     * Base language
     */
    @Prop({ type: String, default: 'fa' }) lang!: string;
}

export default Props;
